import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DraftFile } from 'src/generated/graphql-types';

/**
 * @description - Status of the synced process of the files for the given id from the server
 */
export enum syncFilesWithServerEnum {
  SYNCED = 'SYNCED',
  NOT_SYNCED = 'NOT_SYNCED',
  PENDING = 'PENDING',
  DOCUMENT_CENTER_ONLY = 'DOCUMENT_CENTER_ONLY', // synced only with document center
}

/**
 * @description - This type is used to store the files , fund page, portfolio page, project page or investor personal files
 */
export type SyncedFiles = {
  files: DraftFile[]; //files of the operator page, fund page, portfolio page, project page or investor personal files
  //In case of investor personal files the id is the related entity id
  id: string; //id of the operator page, fund page, portfolio page, project page or investor personal files
  syncWithServer: syncFilesWithServerEnum; //if true, the files have changes and a new server request is needed
};

const initialState = {
  files: [],
  filesDict: {},
  syncedFiles: [] as SyncedFiles[],
  loadingUploadProgressBar: false,
  totalToLoad: 0,
  allFiles: [],
  investedByImages: [], //images for the invested by section in the overview page. Uses different API from syncFilesWithServerEnum
};

const user = createSlice({
  name: 'files',
  initialState,
  reducers: {
    setFiles(state, { payload }: PayloadAction<DraftFile[]>) {
      state['files'] = payload;
    },
    addFiles(state, { payload }: PayloadAction<DraftFile[]>) {
      state['files'] = [...state.files, ...payload];
    },
    setFilesDict(state, { payload }: PayloadAction<any>) {
      state['filesDict'] = { ...state.filesDict, ...payload };
    },
    setSyncedFiles(state, { payload }: PayloadAction<SyncedFiles[]>) {
      state['syncedFiles'] = payload;
    },
    setLoadingUploadProgressBar(state, { payload }: PayloadAction<boolean>) {
      state['loadingUploadProgressBar'] = payload;
    },
    setTotalToLoad(state, { payload }: PayloadAction<number>) {
      state['totalToLoad'] = payload;
    },
    setAllFiles(state, { payload }: PayloadAction<DraftFile[]>) {
      state['allFiles'] = payload;
    },
    setInvestedByImages(state, { payload }: PayloadAction<any>) {
      state['investedByImages'] = payload;
    },
  },
});

export const {
  setFiles,
  addFiles,
  setFilesDict,
  setSyncedFiles,
  setLoadingUploadProgressBar,
  setTotalToLoad,
  setAllFiles,
  setInvestedByImages,
} = user.actions;

export default user.reducer;
